import { render, staticRenderFns } from "./RecallSurvey.vue?vue&type=template&id=9969263c&"
import script from "./RecallSurvey.vue?vue&type=script&lang=js&"
export * from "./RecallSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports